module.exports = __webpack_public_path__ + "img/circle-heart.68835595.svg";